import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DescribedImage, Exhibitor } from '@planone/bau365/util-fair-data';
import { SwiperInteractionEvent } from '@planone/shared/data-access-swiper';
import { CookieConsentFacade } from '@planone/shared/feature-cookie-consent';
import { Observable } from 'rxjs';

@Component({
  selector: 'bau365-exhibitor-section-media',
  templateUrl: './section-media.component.html',
})
export class SectionExhibitorMediaComponent {
  @Input() exhibitor?: Exhibitor;

  @Output() tabChange: EventEmitter<MatTabChangeEvent> = new EventEmitter<MatTabChangeEvent>();
  @Output() swiperInteraction: EventEmitter<SwiperInteractionEvent> = new EventEmitter<SwiperInteractionEvent>();
  @Output() imageZoomChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  cookieConsent$: Observable<boolean | undefined>;

  constructor(cookieConsentFacade: CookieConsentFacade) {
    this.cookieConsent$ = cookieConsentFacade.accepted$;
  }

  trackTabChange = (event: MatTabChangeEvent) => this.tabChange.emit(event);

  trackSwiperInteraction = (event: SwiperInteractionEvent) => this.swiperInteraction.emit(event);

  imageZoomed = (value: boolean) => this.imageZoomChange.emit(value);

  identifyImage(_index: number, image: DescribedImage): string {
    return `${image.provider}/${image.resource}`;
  }
}
